import ContextChatPanel from "../../../../components/messages/ContextChatPanel";

export default function Client360TeamTab({
    profileId,
    customerName,
}: {
    profileId: string;
    customerName: string;
}) {
    const title = customerName.trim() !== "" ? `Екип: ${customerName}` : `Екип: ${profileId}`;

    return (
        <ContextChatPanel
            contextType="client"
            contextId={profileId}
            title={title}
        />
    );
}
